module.exports = __webpack_public_path__ + "img/Bodice-Front-model up and bottom-width3068.052b1287.png";